import type { Text } from 'mdast';
import { text as originalText } from 'mdast-util-to-markdown/lib/handle/text';
import type mdast from 'mdast-util-to-markdown/lib/types';

const underscoreEscapes: mdast.Unsafe[] = [
  { before: '[^A-Za-z\\d]', character: '_', inConstruct: 'phrasing' },
  { character: '_', after: '[^A-Za-z\\d]', inConstruct: 'phrasing' },
  { atBreak: true, character: '_' },
];

export function text(
  node: Text,
  parent: mdast.Parent | null | undefined,
  context: mdast.Context,
  safeOptions: mdast.SafeOptions,
): string {
  // Filter out any escape patterns that apply to the _ character from the default array.
  // Replace it with patterns that work for our case.
  const customUnsafe = context.unsafe.filter(escape => escape.character !== '_');
  const customContext: mdast.Context = {
    ...context,
    unsafe: [...customUnsafe, ...underscoreEscapes],
  };

  return originalText(node, parent, customContext, safeOptions);
}
